import MAYA from "../../../maya_api";
import {setLoadingContent} from '../../../layouts/Content/modules/loadingContent'
import {PRODUCT_TYPES} from "../../../constants";

// ------------------------------------
// Constants
// ------------------------------------

const LOAD_PRODUCTS = 'LOAD_PRODUCTS';
const LOAD_SINGLE_PRODUCTS = 'LOAD_SINGLE_PRODUCTS';
const SELECT_PRODUCT = 'SELECT_PRODUCT';
const CHANGE_SEARCH_TERM = 'CHANGE_SEARCH_TERM';

// ------------------------------------
// Actions
// ------------------------------------
function loadProducts() {
  return async(dispatch, getStore) => {
    const selectedCategory = getStore().categories.selectedCategory;
    let result = [];

    if(!selectedCategory){
      return console.error('Selected category not found');
    }

    dispatch(setLoadingContent(true));

    if(PRODUCT_TYPES[selectedCategory]){
      result = await MAYA.getProductsByType(selectedCategory)
    } else {
      result = await MAYA.getProducts(selectedCategory);
    }

    dispatch(setLoadingContent(false));

    dispatch({
      type    : LOAD_PRODUCTS,
      payload : result
    });
  };
}

function loadSingleProducts() {
  return async(dispatch, getStore) => {

    dispatch(setLoadingContent(true));
    let result = await MAYA.getSingleProducts();
    dispatch(setLoadingContent(false));

    dispatch({
      type    : LOAD_SINGLE_PRODUCTS,
      payload : result
    });
  }
}

function selectProduct(value = 0) {
  return {
    type    : SELECT_PRODUCT,
    payload : value
  }
}

function changeSearchTerm(value = '') {
  return {
    type    : CHANGE_SEARCH_TERM,
    payload : value
  }
}

export {
  loadProducts,
  selectProduct,
  changeSearchTerm,
  loadSingleProducts
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [LOAD_PRODUCTS]: (state, action) => ({
    ...state,
    list: action.payload,
    searchTerm: ''
  }),
  [LOAD_SINGLE_PRODUCTS]: (state, action) => ({
    ...state,
    singleProducts: action.payload
  }),
  [SELECT_PRODUCT]: (state, action) => ({
    ...state,
    selectedProduct: action.payload
  }),
  [CHANGE_SEARCH_TERM]: (state, action) => ({
    ...state,
    searchTerm: action.payload
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  selectedProduct: null,
  searchTerm: '',
  list: [],
  singleProducts: []
};

export default function productsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}





// WEBPACK FOOTER //
// ./src/components/Products/modules/products.js